<template>
  <div class="bg-white m-auto mr-0 overflow-hidden" style="max-width: 960px">
    <div class="fixed w-full z-20" style="max-width: 960px">
      <div
        class="relative flex items-center justify-center h-12 bg-white m-auto"
        style="box-shadow: 0px 0px 8px rgba(152, 163, 190, 0.3)"
      >
        <div class="absolute top-0 flex items-center h-12" style="left: 20px">
          <img
            class="w-6 cursor-pointer"
            src="@/assets/icons/Exit.svg"
            @click="this.$emit('close-modal')"
          />
        </div>
        <span class="text-gray-92 text-base font-semibold">
          {{ state.companyName }}
        </span>
        <div
          v-if="
            companyDetail.dataType == 'public' ||
            serviceDetail.dataType == 'public'
          "
          class="absolute top-0 flex items-center h-12"
          style="right: 20px"
        >
          <span
            class="px-4 rounded-full font-semibold"
            style="
              line-height: 22px;
              background-color: rgba(73, 160, 174, 0.1);
              color: #49a8ae;
            "
          >
            公開中の情報
          </span>
        </div>
        <div
          v-if="
            companyDetail.dataType == 'preview' ||
            serviceDetail.dataType == 'preview'
          "
          class="absolute top-0 flex items-center h-12"
          style="right: 20px"
        >
          <span
            class="px-4 rounded-full font-semibold"
            style="
              line-height: 22px;
              background-color: rgba(73, 160, 174, 0.1);
              color: #49a8ae;
            "
          >
            プレビュー
          </span>
        </div>
      </div>
      <div
        v-if="
          companyDetail.dataType != 'public' &&
          serviceDetail.dataType != 'public' &&
          companyDetail.dataType != 'preview' &&
          serviceDetail.dataType != 'preview'
        "
        class="bg-slate-50"
        style="box-shadow: 0px 8px 8px -8px rgba(152, 163, 190, 0.6)"
      >
        <div
          class="flex items-center h-12 mx-auto px-20"
          style="max-width: 960px; line-height: 48px"
        >
          <div
            class="text-gray-62 font-semibold mr-10"
            :class="{
              'border-b-2 border-secondary-main text-gray-92':
                viewMode === 'company',
            }"
          >
            企業情報
          </div>
          <div class="relative">
            <div
              class="flex items-center text-gray-62 font-semibold mr-10"
              :class="{
                'border-b-2 border-secondary-main text-gray-92':
                  viewMode === 'service',
              }"
            >
              サービス情報
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-12 pt-24">
      <CompServiceDetail
        v-if="viewMode === 'service'"
        :detail="serviceDetail"
      />
      <CompCompanyDetail
        v-if="viewMode === 'company'"
        :detail="companyDetail"
      />
    </div>
  </div>
</template>

<script>
import { reactive, computed } from 'vue';
import CompServiceDetail from '@/components/modalRight/service/ServiceDetail.vue';
import CompCompanyDetail from '@/components/modalRight/service/CompanyDetail.vue';
export default {
  props: {
    viewMode: {
      type: String,
      required: true,
      default: '',
    },
    serviceDetail: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
    companyDetail: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
  },
  components: {
    CompServiceDetail,
    CompCompanyDetail,
  },
  emits: ['close-modal'],
  setup(props) {
    const state = reactive({
      serviceId: computed(() => {
        if (Object.keys(props.serviceDetail).length) {
          return props.serviceDetail.id;
        } else {
          return null;
        }
      }),
      companyId: computed(() => {
        if (Object.keys(props.companyDetail).length) {
          return props.companyDetail.id;
        } else if (Object.keys(props.serviceDetail).length) {
          return props.serviceDetail.company_id;
        } else {
          return null;
        }
      }),
      isPartner: computed(() => {
        if (Object.keys(props.companyDetail).length) {
          return props.companyDetail.is_partner;
        } else if (Object.keys(props.serviceDetail).length) {
          return props.serviceDetail.is_partner;
        } else {
          return null;
        }
      }),
      companyName: computed(() => {
        if (Object.keys(props.companyDetail).length) {
          return props.companyDetail.name;
        } else if (Object.keys(props.serviceDetail).length) {
          return props.serviceDetail.company_name;
        } else {
          return '';
        }
      }),
      services: computed(() => {
        if (Object.keys(props.serviceDetail).length) {
          let services = [
            {
              id: props.serviceDetail.id,
              category_name: props.serviceDetail.category_name,
            },
          ];
          services = services.concat(props.serviceDetail.other_services);
          return services;
        } else if (Object.keys(props.companyDetail).length) {
          return props.companyDetail.services;
        } else {
          return [];
        }
      }),
      openServiceList: false,
    });
    return {
      state,
    };
  },
};
</script>

<style lang="scss" scoped></style>
